export default __webpack_public_path__ + "static/media/GHSI Board Diversity Policy.b00d309c.pdf";